import { formatDate } from '@Utils/business'
import trackDirective from './trackDirective'
import showtip from './showtip'

export const useDirective = app => {
  /**
   * @description 文本框右下角显示输入字数
   * v-byte="255"   参数limit：限制字符数
   */

  app.directive('byte', {
    beforeMount: function (el, binding, vnode, oldVnode) {
      const limit = binding.value || 255
      if (el) {
        const input = el.querySelector('input') || el.querySelector('.bd-textarea__inner') || el.querySelector('textarea')
        const node = document.createElement('div')
        const textnode = document.createTextNode(`${input?.value?.length ?? 0}/${limit}`)
        node.appendChild(textnode)
        node.className = 'byte'
        node.style.position = 'absolute'
        node.style.right = '12px'
        node.style.bottom = '6px'
        node.style.color = '#ccc'
        node.style.display = 'flex'
        node.style.alignItems = 'center'
        node.style.justifyContent = 'center'
        el.appendChild(node)
        el.className += ' byte-input'
      }
    },
    updated: function (el, binding, vnode, oldVnode) {
      const limit = binding.value || 255
      if (el) {
        const input = el.querySelector('input') || el.querySelector('.bd-textarea__inner') || el.querySelector('textarea')
        const len = input?.value.length || 0
        el.querySelector('.byte').innerHTML = `${len}/${limit}`
      }
    }
  })

  app.directive('format-date', {
    beforeMount: function (el, binding, vnode, oldVnode) {
      return formatDate(binding.value, 'yyyy-MM-dd')
    },
    updated: function (el, binding, vnode, oldVnode) {
      return binding.value ? formatDate(new Date(), 'yyyy-MM-dd') : '--'
    }
  })

  app.directive('set-report-scroll-track', {
    beforeMount: function (el, binding, vnode, oldVnode) {
      el.__setReportScrollTracked = false
    },
    updated: function (el, binding, vnode, oldVnode) {
      if (!el.__setReportScrollTracked) {
        window.setTimeout(() => {
          if (window.reportObserver && window.reportObserver.scrollTracker) {
            window.reportObserver.scrollTracker.addScrollListenNode(el)
            el.__setReportScrollTracked = true
          }
        }, 10)
      }
    }
  })

  app.directive('track', trackDirective)

  app.directive('showtip', showtip)
}
